/**
 * SettingsNav — thin sub-navigation shell mounted at /settings.
 *
 * Settings is the sole top-level Ops nav item (see Layout.jsx); Team is
 * reachable only through this internal "Settings | Team" tab strip, and
 * the legacy top-level /team path redirects here (see App.js). No
 * SensitivePageGate is added — Team was not gated before this move and
 * this relocation does not change that.
 */
import SectionNav from "@/components/SectionNav";
import { prefetchTeam } from "@/features/team/teamQueryClient";
import { Outlet } from "react-router-dom";

function prefetchTeamChunk() {
  void import("@/features/team/TeamV2Root");
}

function warmTeam() {
  prefetchTeamChunk();
  void prefetchTeam();
}

const TABS = [
  { to: "/settings", label: "Settings", end: true },
  {
    to: "/settings/team",
    label: "Team",
    end: false,
    onHover: warmTeam,
  },
];

export default function SettingsNav() {
  return (
    <div data-testid="settings-nav">
      <SectionNav tabs={TABS} ariaLabel="Settings sections" testIdPrefix="settings" />
      <Outlet />
    </div>
  );
}
